import React from 'react';
import DataGridToolbar from 'components/datagrid/DataGridToolbar';

interface Props {
	dateRange: string;
}

const CustomersTableToolbar = (props: Props) => {
	const { dateRange } = props;
	return (
		<DataGridToolbar
			persistKey="CustomersTable"
			exportFileName="rentle-customers"
			selectedRowsActions={{
				deleteAction: {
					enabled: false,
					handler: () => {},
				},
				exportAction: {
					enabled: true,
				},
			}}
			dateRange={dateRange}
		/>
	);
};

export default CustomersTableToolbar;
